module.exports = {
  name: "santexpo",
  client: "PG ORGANISATION",
  description: "Mobile app for SANTEXPO 2021",
  validLangs: ["fr", "en"],
  version: {
    mainVersion: "2.0.0",
    buildVersion: {
      iOS: "48",
      android: "47",
      web: "48"
    }
  },
  native: {
    author: "Mobile-Spot",
    backgroundColor: "0xffffff",
    // iOS
    // appleTeamId: '2BAP3P29V2',
    // iosAppStoreUrl: 'https://itunes.apple.com/app/paris-air-show/id1484463502',
    iosBuildTarget: "11.0",
    // Android
    // 'androidapp-id': 'TODO', // unused?
    // playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mobilespot.sofcot',
    androidFadeSplashScreenDuration: 750,
    androidTargetSdkVersion: 30,
    androidSigning: {
      keyAlias: "mobilespot",
      keyStorePassword: "jee1Uu0Hieloh7bi"
    },
    // Web app to wrap in the cordova app ('ionic/www', 'simple', 'test', 'demo', 'app-react' - see cordova/testapps/)
    app: "app-react"
  },
  undeliveredFolders: ["source", "exports"],
  // which additional repos need to be cloned
  relatedRepos: [{
    src: "git@bitbucket.org:mobilespotdev/cordova.git",
    postCommands: ["cd cordova && npm install"],
    branch: "inte/santexpo/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo.git",
    branch: "inte/santexpo/main",
    postCommands: ["cd mobigeo && npm install"]
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo-customs-santexpo.git",
    branch: "inte/santexpo/main",
    dest: "mobigeo/mobigeo-customs"
  }, {
    src: "git@bitbucket.org:mobilespotdev/app-react.git",
    branch: "inte/santexpo/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/data-santexpo.git",
    branch: "inte/santexpo/main",
    dest: "app-react/data",
    postCommands: ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }],
  crypto: false,
  cordova_plugins: {
    mobigeo_plugin_dependencies: [],
    app_dependencies: [{
      id: "../src-app-plugins/cordova-plugin-mobilespot-app",
      variable: "HOST",
      varValue: "web.url"
    }, {
      id: "../src-app-plugins/cordova-plugin-mobilespot-badge-scan"
    }, {
      id: "cordova-plugin-file"
    }, {
      id: "cordova-plugin-file-opener2",
      variable: "ANDROID_SUPPORT_V4_VERSION",
      rawVarValue: "27.+"
    }]
  },
  web: {}
};